var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar-item-container"},[_c('router-link',{attrs:{"to":_vm.url}},[_c('div',{staticClass:"sidebar-item"},[_c('div',{staticClass:"sidebar-item__icon-container"},[_c('span',{staticClass:"sidebar-item__icon"},[_vm._t("icon")],2)]),_c('div',{staticClass:"sidebar-item__title"},[_c('p',[_vm._v(_vm._s(_vm.title))])])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }